"use strict";
$(() => {
  $("#awesome-map").on("ready.decidim", (_e, map) => {
    const hashtagCompare = (a, b) => {
      if (a.toLowerCase().startsWith("#metropoli")) {
        a = ` ${a}`;
      }
      if (b.toLowerCase().startsWith("#metropoli")) {
        b = ` ${b}`;
      }
      return a.localeCompare(b);
    };
    window.AwesomeMap.controls.onHashtag = (hashtag, $div) => {
      let $last = $div.contents("label:last");
      if ($last.prev("label").length) {
        $div.contents("label").each((_idx, el) => {
          if (hashtagCompare($(el).text(), $last.text()) > 0) {
            $(el).before($last);
            return false;
          }
        });
      }
    };
  });
});
